'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _superagentBluebirdPromise = require('superagent-bluebird-promise');

var _superagentBluebirdPromise2 = _interopRequireDefault(_superagentBluebirdPromise);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _Storage = require('./Storage');

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FAN_PRODUCT_PROD_HOST = 'https://fan.api.espn.com';
var FAN_CORE_PROD_HOST = 'https://fan.core.api.espn.com';
var DEFAULT_SOURCE_HEADER = 'espn-video-player'; // watchespn-web // ESPN.com - FAM
var FAN_API_CACHE_MINUTES = 10;
var SWID_RE = /^{[\w-]+}/;

var DEFAULT_CONFIGURATION = {
    sourceHeader: DEFAULT_SOURCE_HEADER,
    cacheDuration: FAN_API_CACHE_MINUTES
};

var _sourceHeader = void 0;
var _cacheDuration = void 0;
var _storage = void 0;

function getFan(id, resolve, reject) {
    var url = FAN_PRODUCT_PROD_HOST + '/apis/v2/fans/' + id;
    _superagentBluebirdPromise2.default.get(url).withCredentials().set('X-Personalization-Source', _sourceHeader).end(function (err, res) {
        if (err || !res.ok) {
            reject(err);
        } else {
            var fan = res && res.body;
            _storage.setFan({ item: fan, id: fan.id, timestamp: Date.now() });
            resolve(fan);
        }
    });
}

function getFanForId(id) {
    if (!SWID_RE.test(id)) {
        return _bluebird2.default.reject(new Error('Invalid SWID'));
    }

    return new _bluebird2.default(function (resolve, reject) {
        _storage.getFan().then(function (cache) {
            var fan = cache && cache.item;
            var cacheExpired = Date.now() - cache.timestamp > _cacheDuration * 60 * 1000;
            if (fan === null || fan.id !== id || cacheExpired) {
                getFan(id, resolve, reject);
            } else {
                resolve(fan);
            }
        }).catch(function () {
            getFan(id, resolve, reject);
        });
    });
}

function updateSettingsForFanId(id, postData) {
    if (!SWID_RE.test(id)) {
        return _bluebird2.default.reject(new Error('Invalid SWID'));
    }

    var url = FAN_CORE_PROD_HOST + '/apis/v2/fans/' + id + '/profile/';
    return _superagentBluebirdPromise2.default.post(url).withCredentials().set('X-Personalization-Source', _sourceHeader).send(postData).promise();
}

function FanAPI() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_CONFIGURATION,
        _ref$sourceHeader = _ref.sourceHeader,
        sourceHeader = _ref$sourceHeader === undefined ? DEFAULT_CONFIGURATION.sourceHeader : _ref$sourceHeader,
        _ref$cacheDuration = _ref.cacheDuration,
        cacheDuration = _ref$cacheDuration === undefined ? DEFAULT_CONFIGURATION.cacheDuration : _ref$cacheDuration;

    if (!(this instanceof FanAPI)) {
        return new FanAPI({ sourceHeader: sourceHeader, cacheDuration: cacheDuration });
    }
    _sourceHeader = sourceHeader;
    _cacheDuration = cacheDuration;
    _storage = new _Storage2.default(_cacheDuration);
    return this;
}

FanAPI.prototype.getFanForId = function (id, callback) {
    return getFanForId(id).tap(function (fan) {
        if (typeof callback === 'function') callback(fan);
    });
};

FanAPI.prototype.getAutoStartForFanId = function (id, callback) {
    return getFanForId(id).then(function (fan) {
        var profile = fan && fan.profile;
        var settings = profile && profile.settings;
        var videoAutoStartValue = settings && settings.videoAutoStart && settings.videoAutoStart.value;
        return videoAutoStartValue !== '2';
    }).catch(function () {
        return true;
    }).tap(function (videoAutoStart) {
        if (typeof callback === 'function') {
            callback(videoAutoStart);
        }
    });
};

FanAPI.prototype.updateAutoStartForFanId = function (id, autoStart, callback) {
    var videoAutoStartValue = (autoStart ? '1' : '2').toString();

    var postData = {
        settings: {
            videoAutoStart: {
                value: videoAutoStartValue,
                lastUpdateSource: _sourceHeader,
                lastUpdateDate: Date.now()
            }
        }
    };

    return updateSettingsForFanId(id, postData).tap(function (err, res) {
        if (typeof callback === 'function') {
            callback(err, res);
        }
    }).catch(function () {
        return true;
    }).finally(function () {
        FanAPI.prototype.updateAutoStartCache(postData.settings);
    });
};

FanAPI.prototype.updateAutoStartCache = function (settings) {
    var videoAutoStart = settings.videoAutoStart;
    _storage.getFan().then(function (cache) {
        var fan = cache && cache.item;
        // const cacheExpired = (Date.now() - cache.timestamp > _cacheDuration * 60 * 1000);
        Object.keys(videoAutoStart).forEach(function (key) {
            fan.profile.settings.videoAutoStart[key] = videoAutoStart[key];
        });
        _storage.setFan({ item: fan, id: fan.id, timestamp: Date.now() });
    }).catch(function () {});
};

FanAPI.prototype.getUidsForFanId = function (id, callback) {
    function hasUid(preference) {
        return preference.metaData.team || preference.metaData.sport;
    }

    function collectUids(preference) {
        if (preference.metaData.team) {
            return preference.metaData.team.uid;
        } else if (preference.metaData.sport) {
            return preference.metaData.sport.uid;
        }
        return null;
    }

    return getFanForId(id).then(function (fan) {
        var preferences = fan && fan.preferences;
        return preferences.filter(hasUid).map(collectUids);
    }).catch(function () {
        return [];
    }).tap(function (uids) {
        if (typeof callback === 'function') {
            callback(uids);
        }
    });
};

exports.default = FanAPI;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/watch-fanapi/dist/FanAPI.js
// module id = 687
// module chunks = 1